export enum SyncProcessLogSeverityEnum {
    Info = 0,
    Warning = 1,
    Error = 2,
}